import * as React from "react";
import Svg, { Path } from "react-native-svg";

function SvgComponent(props) {
  return (
    <Svg width={20} height={20} viewBox="0 0 20 20" fill="none" {...props}>
      <Path
        d="M19.611 15.903l-2.217-1.478-1.971-1.314a.873.873 0 00-1.172.19l-1.22 1.568a.868.868 0 01-1.11.23c-.827-.46-1.805-.893-3.965-3.055-2.159-2.162-2.595-3.138-3.055-3.966a.869.869 0 01.23-1.109l1.567-1.22a.873.873 0 00.19-1.172l-1.273-1.91L4.097.389A.873.873 0 002.92.124L1.17 1.175a2.14 2.14 0 00-.972 1.258C-.28 4.179-.377 8.03 5.796 14.204c6.173 6.174 10.025 6.077 11.771 5.598a2.14 2.14 0 001.258-.972l1.05-1.751a.873.873 0 00-.264-1.176z"
        fill="#000"
      />
    </Svg>
  );
}

export default SvgComponent;
